import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import {
  type IParamsCreateCustomDomain,
  type IParamsCreateShort,
  type IResponseCustomDomain,
  type IResponseCustomDomainError,
  type IResponseShortLink,
  type IResponseUrlShortenerDomains,
} from 'entities/ShortLink/api/types'

class Api {
  createShort(params: IParamsCreateShort): Promise<AxiosResponse<IResponseShortLink[]>> {
    return baseApi.post('url/short', params)
  }

  // Back returns an empty array if no custom domain is set
  getCustomDomain(): Promise<AxiosResponse<IResponseCustomDomain | []>> {
    return baseApi.get('url/custom-domain/get')
  }

  deleteCustomDomain(id: number): Promise<AxiosResponse<{ status: boolean }>> {
    return baseApi.delete(`url/custom-domain/${id}`)
  }

  getUrlShortenerDomains(): Promise<AxiosResponse<IResponseUrlShortenerDomains>> {
    return baseApi.get('url/shortener/domains')
  }

  createCustomDomain(
    params: IParamsCreateCustomDomain
  ): Promise<AxiosResponse<IResponseCustomDomain | IResponseCustomDomainError>> {
    return baseApi.post('url/custom-domain/create', params)
  }

  verifyCustomDomain(id: number | string): Promise<AxiosResponse<IResponseCustomDomain>> {
    return baseApi.post(`url/custom-domain/verify/${id}`)
  }
}

export const ShortLinkApi = new Api()
